module.exports = __webpack_public_path__ + "img/on-demand-white.fa3bce6e.svg";